import React, { useContext } from 'react';
import UserHistoryContext from '../context/UserHistoryContext';
import { useNavigate } from 'react-router-dom';
import './Tooltip.css';

const Tooltip = ({ movie }) => {
  const { getAction, updateAction } = useContext(UserHistoryContext);
  const { watched, liked, disliked } = getAction(movie.movieid);
  const navigate = useNavigate();

  const handleUserAction = async (e, actionType) => {
    e.stopPropagation();
    try {
      await updateAction(movie.movieid, {
        watched: actionType === 'watched' ? !watched : undefined,
        liked: actionType === 'liked' ? !liked : undefined,
        disliked: actionType === 'disliked' ? !disliked : undefined,
      });
    } catch (error) {
      console.error(`Error recording ${actionType} action:`, error);
    }
  };

  const navigateToDetail = (e) => {
    e.stopPropagation();
    navigate(`/detail/${movie.movieid}`, { state: { movie } });
  };

  return (
    <div className="poster-overlay">
      <button
        onClick={(e) => handleUserAction(e, 'watched')}
        className={`overlay-icon-button ${watched ? 'active play' : ''}`}
        title="Watch"
      >
        <i className="fa-solid fa-play"></i>
      </button>
      <button
        onClick={(e) => handleUserAction(e, 'liked')}
        className={`overlay-icon-button ${liked ? 'active like' : ''}`}
        title="Like"
      >
        <i className="fa-solid fa-thumbs-up"></i>
      </button>
      <button
        onClick={(e) => handleUserAction(e, 'disliked')}
        className={`overlay-icon-button ${disliked ? 'active dislike' : ''}`}
        title="Dislike"
      >
        <i className="fa-solid fa-thumbs-down"></i>
      </button>
      <button
        onClick={navigateToDetail}
        className="overlay-icon-button"
        title="Details"
      >
        <i className="fa-solid fa-circle-info"></i>
      </button>
    </div>
  );
};

export default Tooltip;
